import React from 'react';

import {
  InfoFields,
  InfoColumn,
} from 'pages/Order/subcomponents/ItemDetailsTable/styledComponents';
import { ExtendedWarrantyTitle } from './styles/styledComponents';

const ExtendedWarrantyBlock = ({ lineData, darkBackground = false }) => {
  return (
    <>
      <ExtendedWarrantyTitle>Extended Warranty</ExtendedWarrantyTitle>
      <InfoFields spacing="space-between" background={darkBackground ? '#f2f2f2' : '#fff'} padded>
        <InfoColumn>
          <div>
            <b>Line Number</b>: {lineData.displayLineNumber}
          </div>
          <div>
            <b>Part Number</b>: {lineData.partNumber}
          </div>
        </InfoColumn>
        <InfoColumn>
          <div>
            <b>Duration</b>: {lineData.serviceDuration}{' '}
            {lineData.serviceDuration > 1 ? 'Years' : 'Year'}
          </div>
        </InfoColumn>
      </InfoFields>
    </>
  );
};

export { ExtendedWarrantyBlock };
